// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__Bwpp1","cardHeader":"styles_cardHeader__7zdtu","totaluser":"styles_totaluser__QNdxd"};